import { createSelector } from 'reselect';
import { reduxKey } from '../constants';
import { EditorState } from '../types';

function getStoreSlice(state: any): EditorState['extensionGif'] {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey]['extensionGif'];
}

export const gifItems = createSelector(
  getStoreSlice,
  (state: EditorState['extensionGif']) => {
    return state.items;
  }
);

export const gifPage = createSelector(
  getStoreSlice,
  (state: EditorState['extensionGif']) => {
    return state.page;
  }
);

export const gifFetching = createSelector(
  getStoreSlice,
  (state: EditorState['extensionGif']) => {
    return state.fetching;
  }
);

export const gifHasMore = createSelector(
  getStoreSlice,
  (state: EditorState['extensionGif']) => {
    return state.hasMore;
  }
);

export const gifApiError = createSelector(
  getStoreSlice,
  (state: EditorState['extensionGif']) => {
    return state.apiError;
  }
);
